import { AppState } from '../root.reducer';

export const getClaimHasBeenFetched = (state: AppState) => state.claim.hasClaimBeenFetched;
export const getCurrentClaimActionModal = (state: AppState) => state.claim.currentClaimActionModal;
export const getClaimsDownloadStatus = (state: AppState) => state.claim.claimsDownloadStatus;
export const getClaimDeletionPreview = (state: AppState) => state.claim.claimDeletionPreview;
